module.exports = __webpack_public_path__ + "static/sepa_monei-99e236d0083a07169e4764925747e4cd.svg";